import React, { useState, useRef, useEffect } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import { useIsMobile } from '../hooks/useIsMobile';

const COR = '#B51013';

const ajudaIAFn = httpsCallable(functions, 'ajudaIA');

const SUGESTOES = [
  'Como inicio um treinamento?',
  'Por que não consigo avançar para a avaliação?',
  'Como baixo meu certificado?',
  'Não consigo acessar uma tela. O que fazer?',
];

function DigitandoIndicador() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', padding: '10px 14px' }}>
      {[0, 1, 2].map(i => (
        <span
          key={i}
          style={{
            width: 7, height: 7, borderRadius: '50%',
            background: '#bbb',
            display: 'inline-block',
            animation: `bounce 1.2s ease-in-out ${i * 0.2}s infinite`,
          }}
        />
      ))}
      <style>{`
        @keyframes bounce {
          0%, 60%, 100% { transform: translateY(0); opacity: 0.5; }
          30% { transform: translateY(-6px); opacity: 1; }
        }
      `}</style>
    </div>
  );
}

export default function AjudaWidget() {
  const [aberto, setAberto] = useState(false);
  const [mensagens, setMensagens] = useState([]);
  const [input, setInput] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');
  const isMobile = useIsMobile();
  const inputRef = useRef(null);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (aberto && inputRef.current) {
      setTimeout(() => inputRef.current?.focus(), 300);
    }
  }, [aberto]);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [mensagens, carregando]);

  async function enviar(texto) {
    const pergunta = (texto || input).trim();
    if (!pergunta || carregando) return;

    const novasMensagens = [...mensagens, { role: 'user', content: pergunta }];
    setMensagens(novasMensagens);
    setInput('');
    setErro('');
    setCarregando(true);

    try {
      const result = await ajudaIAFn({ mensagens: novasMensagens });
      setMensagens(prev => [...prev, { role: 'assistant', content: result.data.resposta }]);
    } catch (e) {
      console.error('ajudaIA erro:', e);
      setErro('Não foi possível obter resposta. Tente novamente.');
    } finally {
      setCarregando(false);
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      enviar();
    }
  }

  function limparConversa() {
    setMensagens([]);
    setErro('');
    setInput('');
  }

  const botaoBottom = isMobile ? 76 : 24;

  return (
    <>
      {aberto && isMobile && (
        <div
          onClick={() => setAberto(false)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
            zIndex: 1998,
          }}
        />
      )}

      <div style={{
        position: 'fixed',
        bottom: 0,
        right: 0,
        top: isMobile ? 0 : 'auto',
        width: isMobile ? '100%' : '360px',
        height: isMobile ? '100%' : 'min(600px, 90vh)',
        background: '#fff',
        boxShadow: '-4px 0 24px rgba(0,0,0,0.15)',
        borderRadius: isMobile ? '0' : '16px 0 0 16px',
        zIndex: 1999,
        display: 'flex',
        flexDirection: 'column',
        transform: aberto ? 'translateX(0)' : 'translateX(110%)',
        transition: 'transform 0.3s cubic-bezier(0.4,0,0.2,1)',
        overflow: 'hidden',
      }}>
        {/* Cabeçalho */}
        <div style={{
          background: COR, color: '#fff', padding: '14px 16px',
          display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0,
        }}>
          <div style={{
            width: 36, height: 36, borderRadius: '50%',
            background: 'rgba(255,255,255,0.2)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '18px', flexShrink: 0,
          }}>✦</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: '700', fontSize: '15px' }}>Assistente Jatear</div>
            <div style={{ fontSize: '11px', opacity: 0.8 }}>Powered by IA · sempre disponível</div>
          </div>
          {mensagens.length > 0 && (
            <button
              onClick={limparConversa}
              title="Nova conversa"
              style={{
                background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff',
                padding: '4px 8px', borderRadius: '6px', cursor: 'pointer',
                fontSize: '11px', fontWeight: '600',
              }}
            >Nova</button>
          )}
          <button
            onClick={() => setAberto(false)}
            style={{
              background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff',
              width: 30, height: 30, borderRadius: '50%', cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '18px', flexShrink: 0,
            }}
          >×</button>
        </div>

        {/* Área de mensagens */}
        <div
          ref={scrollRef}
          style={{
            flex: 1, overflowY: 'auto',
            padding: '16px 14px',
            display: 'flex', flexDirection: 'column', gap: '10px',
          }}
        >
          {mensagens.length === 0 && !carregando && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <div style={{
                background: '#f7f7f7', borderRadius: '12px', padding: '14px',
                fontSize: '13px', color: '#444', lineHeight: '1.55',
              }}>
                Olá! Sou o assistente da plataforma Jatear. Pode me perguntar qualquer coisa sobre treinamentos, certificados, perfil ou acesso ao sistema.
              </div>
              <div style={{
                fontSize: '11px', color: '#aaa', fontWeight: '600',
                textTransform: 'uppercase', letterSpacing: '0.5px', marginTop: '4px',
              }}>
                Sugestões
              </div>
              {SUGESTOES.map((s, i) => (
                <button
                  key={i}
                  onClick={() => enviar(s)}
                  style={{
                    background: '#fff', border: '1.5px solid #efefef',
                    borderRadius: '10px', padding: '10px 12px',
                    fontSize: '13px', color: '#333', cursor: 'pointer',
                    textAlign: 'left', lineHeight: '1.4',
                    transition: 'border-color 0.15s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = COR}
                  onMouseLeave={e => e.currentTarget.style.borderColor = '#efefef'}
                >
                  {s}
                </button>
              ))}
            </div>
          )}

          {mensagens.map((m, i) => (
            <div
              key={i}
              style={{
                display: 'flex',
                justifyContent: m.role === 'user' ? 'flex-end' : 'flex-start',
              }}
            >
              <div style={{
                maxWidth: '85%',
                background: m.role === 'user' ? COR : '#f2f2f2',
                color: m.role === 'user' ? '#fff' : '#222',
                borderRadius: m.role === 'user' ? '14px 14px 4px 14px' : '14px 14px 14px 4px',
                padding: '10px 14px',
                fontSize: '13px',
                lineHeight: '1.55',
                whiteSpace: 'pre-wrap',
              }}>
                {m.content}
              </div>
            </div>
          ))}

          {carregando && (
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <div style={{ background: '#f2f2f2', borderRadius: '14px 14px 14px 4px' }}>
                <DigitandoIndicador />
              </div>
            </div>
          )}

          {erro && (
            <div style={{
              background: '#fff5f5', border: '1px solid #fce0e0',
              borderRadius: '10px', padding: '10px 12px',
              fontSize: '12px', color: COR,
            }}>
              {erro}
            </div>
          )}
        </div>

        {/* Input */}
        <div style={{
          borderTop: '1px solid #f0f0f0',
          padding: '12px',
          display: 'flex', gap: '8px', flexShrink: 0,
          background: '#fff',
        }}>
          <textarea
            ref={inputRef}
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Digite sua dúvida..."
            rows={1}
            style={{
              flex: 1,
              padding: '9px 12px',
              border: '1.5px solid #e0e0e0',
              borderRadius: '10px',
              fontSize: '13px',
              resize: 'none',
              outline: 'none',
              fontFamily: 'inherit',
              lineHeight: '1.4',
              maxHeight: '80px',
              overflowY: 'auto',
              transition: 'border-color 0.2s',
            }}
            onFocus={e => e.target.style.borderColor = COR}
            onBlur={e => e.target.style.borderColor = '#e0e0e0'}
          />
          <button
            onClick={() => enviar()}
            disabled={!input.trim() || carregando}
            style={{
              width: 38, height: 38,
              borderRadius: '10px',
              background: (!input.trim() || carregando) ? '#e0e0e0' : COR,
              border: 'none',
              color: '#fff',
              cursor: (!input.trim() || carregando) ? 'default' : 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0,
              alignSelf: 'flex-end',
              transition: 'background 0.2s',
              fontSize: '16px',
            }}
          >↑</button>
        </div>
      </div>

      {/* Botão flutuante */}
      <button
        onClick={() => setAberto(v => !v)}
        title="Assistente Jatear"
        style={{
          position: 'fixed',
          bottom: botaoBottom,
          right: 20,
          width: 48,
          height: 48,
          borderRadius: '50%',
          background: aberto ? '#888' : COR,
          color: '#fff',
          border: 'none',
          cursor: 'pointer',
          boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '20px',
          zIndex: 2000,
          transition: 'background 0.2s, transform 0.2s',
          transform: aberto ? 'rotate(45deg) scale(0.95)' : 'scale(1)',
        }}
        onMouseEnter={e => { if (!aberto) e.currentTarget.style.transform = 'scale(1.1)'; }}
        onMouseLeave={e => { e.currentTarget.style.transform = aberto ? 'rotate(45deg) scale(0.95)' : 'scale(1)'; }}
      >
        {aberto ? '×' : '✦'}
      </button>
    </>
  );
}
